export default __webpack_public_path__ + "static/media/Osby_full.65dc0a87.png";